import adminAxiosInstance from "./api/adminAxiosInstance";

const searchReceipts = async (
  clientName = "",
  contractId = "",
  withdrawId = "",
  page = 1,
  pageSize = 10
) => {
  const params = new URLSearchParams({
    page,
    pageSize,
  });

  if (clientName) params.append("clientName", clientName);
  if (contractId) params.append("contractId", contractId);
  if (withdrawId) params.append("withdrawId", withdrawId);

  const response = await adminAxiosInstance.get(
    `receipt/search?${params.toString()}`
  );
  return response.data;
};

const createWithdrawReceipt = async (formData) => {
  const response = await adminAxiosInstance.post("receipt/withdraw", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

const createContractReceipt = async (formData) => {
  const response = await adminAxiosInstance.post("receipt/contract", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const receiptService = {
  searchReceipts,
  createWithdrawReceipt,
  createContractReceipt,
};
